import { ApiDateSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const GetDailyEventsDigestedResponseSchema = oz.object({
  dailyEventsDigested: oz.object({
    date: ApiDateSchema,
    count: oz.number(),
  }).array(),
});

export type GetDailyEventsDigestedResponse = oz.infer<typeof GetDailyEventsDigestedResponseSchema>;